export enum PaymentLimitMode {
  fixedDay = 'fixed_day',
  relativeDay = 'relative_day',
  minOfFixedAndRelative = 'min_of_fixed_and_relative',
}

export enum PaymentLimitModeTranslation {
  fixedDay = 'fixed_payment_radio',
  relativeDay = 'relative_payment_radio',
  minOfFixedAndRelative = 'min_fix_rel_payment_radio',
}

export const getPaymentLimitModeFromValue = (value): PaymentLimitMode => {
  if (!value) {
    return value;
  }

  const index = Object.values(PaymentLimitMode).indexOf(value);
  if (index < 0) {
    throw new Error('Unknown payment limit mode category ' + value);
  }

  return Object.keys(PaymentLimitMode)[index] as PaymentLimitMode;
};
